import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import CurrencyDetailTab from './CurrencyDetailTab';
import useDetailHandler from '../../hooks/useDetailHandler';
import { currencyType } from '../../types';
import './_styles_/CurrencyRow.css';
import { onActionKey } from '../../utils';

export const getValueMapping = (t) => ({
    active: [
        {
            from: true,
            to: t('misc.yes'),
        },
        {
            from: false,
            to: t('misc.no'),
        },
    ],
});

CurrencyRow.propTypes = {
    currency: currencyType.isRequired,
};

function CurrencyRow(props) {
    const { currency } = props;
    const { t } = useTranslation();
    const valueMapping = getValueMapping(t);
    const { isDetailVisible, toggleDetail } = useDetailHandler(currency.code);
    return (
        <>
            <div className="rich-list-row currency-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="currency-header--values--code">{currency.code}</div>
                <div className="currency-header--values--name">{currency.name}</div>
                <div className="currency-header--values--exchange-rate">{currency.exchangeRate.toFixed(4)}{t('currencies.exchange-rate-to-euro')}</div>
                <div className="currency-header--values--active">{currency.active ? valueMapping.active[0].to : valueMapping.active[1].to}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && <CurrencyDetailTab currency={currency} />}
        </>
    );
}

export default CurrencyRow;
